var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { Slider as SliderMui, Stack } from '@mui/material';
import { ExpandIcon, ExpandLessIcon } from './Icons';
import { addDays, formatDate, formatDateString, getDatesBetweenTowDates, } from '../services/utils/utils';
import { IconButton } from './IconButton';
export var SliderDate = function (_a) {
    var _b = _a.onChange, onChange = _b === void 0 ? null : _b, _c = _a.minDiff, minDiff = _c === void 0 ? null : _c, _d = _a.maxDiff, maxDiff = _d === void 0 ? null : _d, _e = _a.defaultDebut, defaultDebut = _e === void 0 ? new Date() : _e, _f = _a.defaultFin, defaultFin = _f === void 0 ? new Date() : _f;
    var _g = useState(formatDate(addDays(defaultDebut, -5))), min = _g[0], setMin = _g[1];
    var _h = useState(formatDate(addDays(defaultFin, 5))), max = _h[0], setMax = _h[1];
    var marks = [];
    var index = 0;
    var lastLabelMonth = null;
    var dates = getDatesBetweenTowDates(min, max);
    for (var _i = 0, dates_1 = dates; _i < dates_1.length; _i++) {
        var date = dates_1[_i];
        var labelDate = formatDateString(date);
        marks.push({
            value: index,
            date: formatDate(date),
            label: lastLabelMonth && index !== dates.length - 1
                ? labelDate.replace(lastLabelMonth, '')
                : labelDate,
        });
        lastLabelMonth = [labelDate.split(' ')[2], labelDate.split(' ')[3]].join(' ');
        index++;
    }
    var getMark = function (markSelected) {
        var mark = marks.find(function (mark) { return markSelected === mark.date; });
        return mark ? mark.value : marks[0].value;
    };
    var _j = useState([
        getMark(defaultDebut),
        getMark(defaultFin),
    ]), value = _j[0], setValue = _j[1];
    var handleChange = function (event, newValue) {
        var indexMin = newValue[0];
        var indexMax = newValue[1];
        if (indexMin === value[0] && indexMax === value[1]) {
            event.preventDefault();
            return;
        }
        var moveMax = indexMin === value[0] && indexMax !== value[1];
        var moveMin = indexMax === value[1] && indexMin !== value[0];
        var diff = Math.abs(indexMax - indexMin);
        var hasDiff = (maxDiff !== null && diff > maxDiff) ||
            (minDiff !== null && diff < minDiff);
        if (hasDiff) {
            if (moveMax && maxDiff !== null) {
                indexMin = indexMax - maxDiff;
            }
            else if (moveMin) {
                indexMax = indexMin + (minDiff !== null ? minDiff : maxDiff);
            }
        }
        if (indexMin < 0 || indexMax >= marks.length) {
            event.preventDefault();
            return;
        }
        var markMin = marks.find(function (mark) { return indexMin === mark.value; });
        var markMax = marks.find(function (mark) { return indexMax === mark.value; });
        setValue([indexMin, indexMax]);
        onChange(markMin ? markMin.date : marks[0].value, markMax ? markMax.date : marks[0].value);
    };
    var valueLabelFormat = function (value) {
        return value;
    };
    return (_jsx(_Fragment, { children: _jsxs(Stack, __assign({ direction: "row", justifyContent: "space-between", spacing: 3 }, { children: [_jsx(SliderMui, { sx: { minHeight: 300 }, value: value, min: marks[0].value, max: marks[marks.length - 1].value, getAriaValueText: valueLabelFormat, valueLabelFormat: valueLabelFormat, onChange: handleChange, marks: marks, size: "small", orientation: "vertical" }), _jsxs(Stack, __assign({ justifyContent: "space-between", spacing: 2 }, { children: [_jsxs(Stack, { children: [_jsx(IconButton, __assign({ tooltip: "D\u00E9caler d'un mois", color: "primary", onClick: function () {
                                        setMax(formatDate(addDays(max, 1)));
                                    } }, { children: _jsx(ExpandLessIcon, { fontSize: "small" }) })), _jsx(IconButton, __assign({ tooltip: "D\u00E9caler d'un mois", color: "primary", onClick: function () {
                                        setMax(formatDate(addDays(max, -1)));
                                    }, disabled: getMark(max) === value[1] }, { children: _jsx(ExpandIcon, { fontSize: "small" }) }))] }), _jsxs(Stack, { children: [_jsx(IconButton, __assign({ tooltip: "D\u00E9caler d'un mois", color: "primary", disabled: getMark(min) === value[0], onClick: function () {
                                        setMin(formatDate(addDays(min, 1)));
                                        setValue([value[0] - 1, value[1] - 1]);
                                    } }, { children: _jsx(ExpandLessIcon, { fontSize: "small" }) })), _jsx(IconButton, __assign({ tooltip: "D\u00E9caler d'un mois", color: "primary", onClick: function () {
                                        setMin(formatDate(addDays(min, -1)));
                                        setValue([value[0] + 1, value[1] + 1]);
                                    } }, { children: _jsx(ExpandIcon, { fontSize: "small" }) }))] })] }))] })) }));
};
//# sourceMappingURL=SliderDate.js.map